export const environment = {
  production: true,
  profileUrl : "https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=authenticate",
  quizeUrl : "https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=oqExams",
  sendScoreUrl : "https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=oqPaperSubmit",
  quizePaper : "https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=oqPaper",
  oqPaperSave : "https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=oqPaperSave",
  login:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=authenticate",
  registration:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=registration",
  todaySchedule:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=todaySchedule",
  classroom:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=classroom", 
  joinLive:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=joinLive",
  registrationPayments:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=registrationPayments",
  assignments:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=assignments",
  remarks:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=remarks",
  monthsummary:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=monthsummary",
  fee:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=fee",
  paymentLink:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=paymentLink",
  profile:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=profile",    
  schoolShoppe:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=schoolShoppe",
  schoolShoppeCart:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=schoolShoppeCart",
  schoolShoppeOrders:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=schoolShoppeOrders",
  oqPaper:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=oqPaper",
  oqPaperNew:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=oqPaperNew",
  oqPaperSubmitNew:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=oqPaperSubmitNew",
  diary:"https://rest-dot-tchrnote-remote.appspot.com/ApiParentapp?serviceName=diary",
  forms:'https://rest-dot-tchrnote-remote.appspot.com/forms',
  env: 'prod',
  mode: 'no-cors',
  baseUrl: ''
}; 


// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/environments/environment.prod.ts